import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { useRouteMatch } from "react-router";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Loading } from "../../components/Loading";

const QUERY = gql`
  query merchantSaleDay($day: Int!, $status: [Int]) {
    merchantSaleDay(day: $day, status: $status)
  }
`;

function getParamUrl(type: string) {
  let status: any = [];
  if (type === undefined) {
    status = undefined;
  } else if (type === "return") {
    status = [12];
  } else if (type === "sold") {
    status = [3, 8];
  } else if (type === "remainder") {
    status = [0, 1, 2, 5, 6, 13, 14, 15, 16, 17];
  }
  return status;
}

export function DailySaleScreen() {
  const { params }: any = useRouteMatch();
  const [resData, setItems] = useState<any[]>([]);
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      day: params.id === undefined ? 0 : Number(params.id),
      status: getParamUrl(params.type),
    },
    onCompleted: (res) => {
      const items: any[] = [];
      res.merchantSaleDay.map((x: any) => {
        const index = items.findIndex((i) => i.orderid === x.orderid);
        if (index < 0) {
          items.push({
            orderid: x.orderid,
            ostatus: x.ostatus,
            is_remote_stock_order: x.is_remote_stock_order,
            products: [
              {
                coid: x.coid,
                itemid: x.itemid,
                picture: x.thumb_small,
                code: x.code,
                stock: x.stock,
                sku: [
                  {
                    size: x.size,
                    color: x.color,
                    qty: x.qty,
                    price: x.full_price,
                    fee: x.handling_fee,
                    delivery: x.delivery_fee,
                    commission: x.l192_commission,
                    order_date: x.ordered_date,
                  },
                ],
              },
            ],
          });
        } else {
          const pro = items[index].products.findIndex(
            (s: any) => s.itemid === x.itemid
          );
          if (pro < 0) {
            items[index].products.push({
              coid: x.coid,
              itemid: x.itemid,
              picture: x.thumb_small,
              code: x.code,
              stock: x.stock,
              sku: [
                {
                  size: x.size,
                  color: x.color,
                  qty: x.qty,
                  price: x.full_price,
                  fee: x.handling_fee,
                  delivery: x.delivery_fee,
                  commission: x.l192_commission,
                  order_date: x.ordered_date,
                },
              ],
            });
          } else {
            items[index].products[pro].sku.push({
              size: x.size,
              color: x.color,
              qty: x.qty,
              price: x.full_price,
              fee: x.handling_fee,
              delivery: x.delivery_fee,
              commission: x.l192_commission,
              order_date: x.ordered_date,
            });
          }
        }
        return "";
      });
      setItems(items);
    },
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: "Dashboard",
      to: "/",
    },
    {
      text: params.id ? params.id + " Days" : "Today",
      to: '#',
    },
  ];

  if (data === undefined || loading || resData.length === 0) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock title={params.id ? params.id + " Days" : "Today"}>
          <Loading />
        </SectionBlock>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <SectionBlock title={params.id ? params.id + " Days" : "Today"}>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th className="text-center">IMAGE</th>
              <th className="text-center">CODE</th>
              <th className="text-center">ORDER DATE</th>
              <th className="text-center">SKU</th>
              <th className="text-center">PRICE</th>
              <th className="text-center">STATUS</th>
              <th className="text-center">QTY</th>
              <th className="text-center">STOCK</th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {resData.map((x: any, i: number) => {
              return x.products.map((y: any, j: number) => {
                return y.sku.map((z: any, k: number) => {
                  return (
                    <tr key={i + k}>
                      {k === 0 && (
                        <td
                          style={{ width: 150 }}
                          className="text-center"
                          rowSpan={y.sku.length}
                        >
                          <img
                            src={y.picture!}
                            alt=""
                            style={{ width: 100, height: 140, borderRadius: 4 }}
                          />
                        </td>
                      )}
                      <td className="text-center">{y.code}</td>
                      <td className="text-center">{z.order_date}</td>
                      <td className="text-center">
                        <span>Size: {z.size}</span> <br />
                        <span>Color: {z.color}</span>
                      </td>
                      <td className="text-center">{z.price} USD</td>
                      <td className="text-center">{StatusType[x.ostatus]}</td>
                      <td className="text-center">{z.qty}</td>
                      <td className="text-center">{y.stock}</td>
                      <td className="text-center">
                        {x.is_remote_stock_order === "F"
                          ? "FBL"
                          : "Remote Stock"}
                      </td>
                    </tr>
                  );
                });
              });
            })}
          </tbody>
        </table>
      </SectionBlock>
    </Content>
  );
}

const StatusType = [
  "Wating",
  "Ordering",
  "Arrived",
  "Delivered",
  "Out Of Stock",
  "Ready",
  "Finding",
  "",
  "Instore Purchase",
  "Returning",
  "",
  "Uncollected",
  "Returened",
  "Found",
  "Prepared",
  "Agent Arrived",
  "Merchant Shipped",
  "Shipper Sent",
  "Damaged Item",
  "Wrong Item",
  "Merchant Cancelled",
  "Discountined",
];